import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/inactive/Breadcrumb";
import DepositDetailLayer from "../components/DepositDetailLayer";

const DepositDetailPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Invoice - List" />

        {/* InvoiceListLayer */}
        <DepositDetailLayer />
      </MasterLayout>
    </>
  );
};

export default DepositDetailPage;
